import { Button, Form, Input } from "antd";
import React, { useEffect, useState } from "react";
import { ILoginModel } from "../../models/login";
import { useAppDispatch } from "../../lib/hook";
import { login } from "../../lib/features/user-auth/userAuth.thunk";
import { ErrorPopup } from "../../utilities/swal";
import { resetNavigate } from "../../utilities/navigation";


interface LoginPageProps {
  // Add props here
}

const LoginPage: React.FC<LoginPageProps> = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const handleSubmitLogin = async (values: any) => {
    setLoading(true);
    const data: ILoginModel = {
      ...values,
    };
    await dispatch(login(data)).then((result) => {
      if (result?.type.includes("fulfilled")) {
        form.resetFields();
        resetNavigate("/");
      }
      if (result?.type.includes("rejected")) {
        ErrorPopup(
          "Đăng nhập không thành công",
          result?.payload?.response?.data?.message
        );
      }
    });
    setLoading(false);
  };
  useEffect(() => {
    return () => form.resetFields();
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="bg-gray-50 min-h-screen flex flex-col items-center justify-center px-6 py-8">
      <div className="flex items-center mb-6 text-2xl font-semibold text-gray-900">
        <img
          className="w-8 h-8 mr-2"
          src="https://flowbite.s3.amazonaws.com/blocks/marketing-ui/logo.svg"
          alt="logo"
        />
        BH Travel
      </div>

      <div className="w-full bg-white rounded-lg shadow sm:max-w-md xl:p-0">
        <div className="p-6 space-y-6">
          <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">
            Đăng nhập tài khoản
          </h1>

          <Form
            disabled={loading}
            name="login"
            layout="vertical"
            initialValues={{ remember: true }}
            onFinish={handleSubmitLogin}
          >
            {/* Email */}
            <Form.Item
              label="Tên đăng nhập"
              name="loginId"
              rules={[
                { required: true, message: "Mời bạn điền tên đăng nhập" },
              ]}
            >
              <Input placeholder="name@company.com" />
            </Form.Item>

            {/* Password */}
            <Form.Item
              label="Mật khẩu"
              name="password"
              rules={[
                { required: true, message: "Mời bạn điền mật khẩu" },
                { min: 6, message: "Mật khẩu tối thiểu 6 ký tự" },
              ]}
            >
              <Input.Password placeholder="••••••••" />
            </Form.Item>

            {/* Remember me + Forgot password */}

            {/* Submit button */}
            <Form.Item>
              <Button
                disabled={loading}
                loading={loading}
                type="primary"
                htmlType="submit"
                block
              >
                Đăng nhập
              </Button>
            </Form.Item>

            {/* Footer */}
            <p className="text-sm text-gray-500">
              Bạn chưa có tài khoản?{" "}
              <a href="/" className="font-medium text-blue-600 hover:underline">
                Đăng ký
              </a>
            </p>
          </Form>
        </div>
      </div>
    </section>
  );
};

export default LoginPage;
